export default __webpack_public_path__ + "static/media/ai_trading_4.35471c07.png";